import { AreaMasterThemeModeConfig } from './types';

const dark: AreaMasterThemeModeConfig = {
  areaMaster: {},
};

export default dark;
